// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export class User {
  displayName!: string;
  email!: string;
  avatar!: string;
  timeZone!: string;
}
